<template>
  <div id="HomePage">
    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild">
      <el-carousel
        :interval="4000"
        type=""
        arrow="always"
        height="600px"
        class="certificate-carousel"
        direction="horizontal"
      >
        <el-carousel-item
          v-for="(item, index) in items.carouselImage"
          :key="'cert-' + index"
        >
          <div class="certificate-item">
            <img
              :src="item.image"
              :alt="'证书' + index"
              class="certificate-image"
            />
            <div class="swiper-slide-title">
              <h1>{{ item.introduce[lang].title }}</h1>
              <p>{{ item.introduce[lang].content }}</p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 智能解决方案 -->
    <div
      id="whyChooseUs"
      class="conatiner-fuild"
      style="background-color: #f5f5f5; height: 860px"
    >
      <div class="container" v-for="(item, index) in homeitems2" :key="index">
        <div class="whyChooseUs-title text-center wow slideInUp">
          <p>
            {{ item.content.promotionSlogan[lang] }}
          </p>
          <p>
            {{
              lang === "zh"
                ? item.content.promotionSlogan.en
                : item.content.promotionSlogan.zh
            }}
          </p>
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
            style="margin-top: 80px"
            stretch
          >
            <el-tab-pane
              v-for="(item, index) in item.content.lists"
              style="font-size: 100px"
              :key="index"
              :label="item.name[lang]"
              :name="index.toString()"
            >
              <div id="bigData" class="container-fuild">
                <div class="row bigData-container wow slideInUp">
                  <div class="col-xs-12 col-sm-12 col-md-6 wow zoomIn">
                    <img class="img-responsive" :src="item.icon" alt="" />
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-6">
                    <h2 class="bigData-title">
                      {{ item.title[lang] }}
                      <small
                        >/
                        {{
                          lang === "zh" ? item.title.en : item.title.zh
                        }}</small
                      >
                    </h2>
<!--                    <p>{{ item.introduce[lang] }}</p>-->
                    <div class="text-content-wrapper">
                      <p class="centered-text">{{ item.introduce[lang] }}</p>
                    </div>
<!--                     <p></p>-->
<!--                     <h2 class="bigData-device">PC/PAD/Phone &nbsp; 全设备支持</h2>-->
                    <div
                      data-i18n="homePage_mos"
                      class="btnsty btn-to-translate"
                      @click="RouterService(index)"
                    >
                      查看详情
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <!-- 产品中心 -->
    <div id="whyChooseUs" class="conatiner-fuild product">
      <div class="container" v-for="(item, index) in homeitems1" :key="index">
        <div class="whyChooseUs-title text-center wow slideInUp">
          <p>
            {{ item.content.promotionSlogan[lang] }}
          </p>
          <p>
            {{
              lang === "zh"
                ? item.content.promotionSlogan.en
                : item.content.promotionSlogan.zh
            }}
          </p>
        </div>
        <div class="row">
          <div
            class="col-xs-12 col-sm-6 col-md-4 server-wrapper"
            v-for="(item, index) in item.content.products"
            :key="index"
            @click="goToPage(index)"
          >
            <div
              class="server-block wow slideInUp"
              onmouseenter="this.style.color='#003987';this.style.borderColor='#003987'"
              onmouseleave="this.style.color='#333';this.style.borderColor='#ccc'"
            >
              <img class="center-block" :src="item.icon" alt="logo" />
              <p class="text-center">
                {{ item.name[lang] }}
              </p>
              <div
                class="text-center"
                v-html="item.introduce[lang]"
                onmouseenter="this.style.color='#003987'"
                onmouseleave="this.style.color='#333'"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 成功案例 -->
    <div id="whyChooseUs" class="conatiner-fuild product wow slideInUp">
      <div class="container" v-for="(item, index) in homeitems" :key="index">
        <div class="whyChooseUs-title text-center wow slideInUp">
          <!-- <p>{{ homeitems.content.slogan }}</p> -->
          <!-- <p>多行业、多场景、可借鉴的成功案例</p> -->
          <p>{{ item.content.slogan[lang] }}</p>
          <p>
            {{
              lang === "zh" ? item.content.slogan.en : item.content.slogan.zh
            }}
          </p>
        </div>
        <div class="cg_div"  @click="goToPage1(item)">
          <h4 data-i18n="homePage_cases" class="cg_h4">服务成功案例</h4>
          <h2 class="cg_h2">
            <span class="cg_h2" v-count-up="item.content.number"></span
            >{{ item.content.tailText[lang] }}
          </h2>
        </div>
        <!-- 轮播图 -->
        <div class="anlsty">
          <el-carousel
            :interval="10000"
            type=""
            arrow="never"
            height="465px"
            class="certificate-carousel"
          >
            <el-carousel-item
              v-for="(item, index) in item.content.backgroundImages"
              :key="'cert-' + index"
            >
              <div class="certificate-item">
                <img
                  :src="item"
                  :alt="'证书' + index"
                  class="certificate-image"
                />
                <div class="swiper-slide-title"></div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

      </div>
    </div>
    <!-- 咨询服务 -->
    <div id="whyChooseUs" class="conatiner-fuild product">
      <div class="container" v-for="(item, index) in homeitems4" :key="index">
        <div class="whyChooseUs-title text-center wow slideInUp">
          <p>{{ item.content.slogan[lang] }}</p>
          <p>
            {{
              lang === "zh" ? item.content.slogan.en : item.content.slogan.zh
            }}
          </p>
        </div>
        <div class="index-fw">
          <ul class="width clear index-fw-list wow slideInUp">
            <li v-for="(item, index) in item.content.services" :key="index">
              <img class="fwimgsty" :src="item.backgroundImage" alt="" />
              <a class="index-fw-in" target="_blank" title="">
                <h3 class="over4">{{ item.title[lang] }}</h3>
                <em><img alt="" src="../assets/img/icon_03.png" /></em>
                <p>
                  {{ item.content[lang] }}
                </p>
                <span data-i18n="homePage_now" @click="showConsultDialog"
                  >立即咨询</span
                >
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 咨询弹窗 -->
    <el-dialog
      title="咨询服务"
      :visible.sync="dialogVisible"
      width="50%"
      @close="handleClose"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="form.phone"
            placeholder="请输入您的手机号"
          ></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="mail">
          <el-input
            v-model="form.mail"
            placeholder="请输入您的邮箱"
          ></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="wechat">
          <el-input
            v-model="form.wechat"
            placeholder="请输入您的邮箱"
          ></el-input>
        </el-form-item>

        <el-form-item label="公司名称" prop="company">
          <el-input
            v-model="form.company"
            placeholder="请输入您的公司名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="咨询项目" prop="attention">
          <el-select
            v-model="form.attention"
            placeholder="请选择咨询项目"
            style="width: 100%"
          >
            <el-option
              v-for="item in projectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="详细需求">
          <el-input
            type="textarea"
            :rows="4"
            v-model="form.remark"
            placeholder="请简要描述您的需求"
          >
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 为什么选择我们 -->

    <!--数字滚动-->
<!--    <div-->
<!--      class="numberBot"-->
<!--      style="margin-top: 100px"-->
<!--      v-for="(item, index) in homeitems5"-->
<!--      :key="index"-->
<!--    >-->
<!--      <p>{{ item.type }}</p>-->
<!--      <ul class="width clear number">-->
<!--        <li v-for="(item, index) in item.content.numbers" :key="index">-->
<!--          <h3>-->
<!--            <span class="counter" v-count-up="item.value" id="gscl"></span-->
<!--            >{{ item.tailText[lang] }}-->
<!--          </h3>-->
<!--          <p>{{ item.description[lang] }}</p>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
  </div>
</template>
<script>
import axios from "axios";
import Swiper from "swiper";
import { WOW } from "wowjs";
import { websiteUrl, fileUrl } from "../../url.js"; //全局配置URL ip
// 引入翻译变量
import { sharedState } from "../assets/js/languages/fanyi";
import { translatePage } from "../assets/js/languages/change_language";

export default {
  name: "HomePage",
  //动态数字
  directives: {
    countUp: {
      bind(el, binding) {
        let current = 0;
        const target = binding.value;
        const duration = 1500; // ms
        const increment = target / (duration / 16); // 每帧增量

        // console.log(binding.value);
        const update = () => {
          current += increment;
          if (current < target) {
            el.textContent = Math.ceil(current);
            requestAnimationFrame(update);
          } else {
            el.textContent = target;
          }
        };
        // 页面进入视口触发函数
        let observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              update();
              observer.unobserve(el);
            }
          });
        });
        observer.observe(el);

        // update();
      },
      // update(el, binding) {
      //   // 值更新时重新执行动画
      //   const newshuzi = binding.shuzi;
      //   const oldshuzi = binding.oldshuzi;
      //   console.log(binding)
      //   if (newshuzi !== oldshuzi) {
      //     // 这里可以添加更完善的更新逻辑
      //     el.textContent = newshuzi;
      //   }
      // },
    },
  },
  data() {
    return {
      items: [],
      homeitems: [],
      homeitems1: [],
      homeitems2: [],
      homeitems4: [],
      homeitems5: [],
      activeName: "0",
      //提交
      dialogVisible: false, // 控制弹窗显示
      form: {
        name: "",
        phone: "",
        company: "",
        attention: "",
        mail:"",
        wechat:"",
        remark: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        attention: [
          { required: true, message: "请选择咨询项目", trigger: "change" },
        ],
      },
      projectOptions: [
        { label: "产品咨询", value: "product" },
        { label: "解决方案咨询", value: "solution" },
        { label: "技术服务", value: "tech" },
        { label: "其他", value: "other" },
      ],
    };
  },
  created() {
    this.getHomeswiper(); // 获取轮播数据
    this.getHomepage1(); // 进入页面时自动获取数据
    this.getHomepage2(); // 进入页面时自动获取数据
    this.getHomepage3(); // 进入页面时自动获取数据
    this.getHomepage4(); // 进入页面时自动获取数据
    this.getHomepage5(); // 进入页面时自动获取数据
  },
  // 语言变量 计算属性
  computed: {
    lang() {
      return sharedState.lang;
    },
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      this.getHomepage1();
      // WOW.js 会把初始化时处于隐藏 tab 里的元素设为 visibility:hidden，需触发一次 scroll 让它重新检测并显示
      this.$nextTick(() => window.dispatchEvent(new Event("scroll")));
    },

    //获取轮播数据信息
    async getHomeswiper() {
      const cache = localStorage.getItem("swiperData");
      if (cache) {
        this.items = JSON.parse(cache);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/homepage/getInfo/1`
        );
        const data = response.data.data;

        if (typeof data.carouselImage === "string") {
          data.carouselImage = JSON.parse(data.carouselImage);
          for (let i = 0; i < data.carouselImage.length; i++) {
            if (data.carouselImage[i].image) {
              data.carouselImage[i].image =
                fileUrl + data.carouselImage[i].image;
              // data.address = JSON.parse(data.address);
            }
          }
        }
        this.items = response.data.data;
        console.log(this.items, "homepage");
        localStorage.setItem("swiperData", JSON.stringify(this.items));
        this.$nextTick(() => {
          this.initSwiper(); // 数据更新后初始化 Swiper
        });
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    //获取页面内容-产品中心
    async getHomepage1() {
      const cache = localStorage.getItem("homeData1");
      if (cache) {
        this.homeitems1 = JSON.parse(cache);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/homepageContent/list?type=1`
        );
        const data = response.data.rows;

        if (Array.isArray(data)) {
          for (let i = 0; i < data.length; i++) {
            if (typeof data[i].content === "string") {
              try {
                data[i].content = JSON.parse(data[i].content);
                // 检查是否存在 products 数组
                if (
                  data[i].content.products &&
                  Array.isArray(data[i].content.products)
                ) {
                  // 遍历每一个 product，并修改 icon
                  for (let j = 0; j < data[i].content.products.length; j++) {
                    if (data[i].content.products[j].icon) {
                      data[i].content.products[j].icon =
                        fileUrl + data[i].content.products[j].icon;
                    }
                  }
                }
              } catch (error) {
                console.error("JSON 解析失败:", error);
                data[i].content = null; // 或保持原字符串
              }
            }
          }
        }
        this.homeitems1 = response.data.rows;
        console.log(this.homeitems1, "产品中心");
        localStorage.setItem("homeData1", JSON.stringify(this.homeitems1));
        this.$nextTick(() => {
          this.initSwiper(); // 数据更新后初始化 Swiper
        });
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    //获取页面内容-解决方案
    async getHomepage2() {
      const cache = localStorage.getItem("homeData2");
      if (cache) {
        this.homeitems2 = JSON.parse(cache);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/homepageContent/list?type=2`
        );
        const data = response.data.rows;

        if (Array.isArray(data)) {
          for (let i = 0; i < data.length; i++) {
            if (typeof data[i].content === "string") {
              try {
                data[i].content = JSON.parse(data[i].content);
                // 检查是否存在 lists 数组
                if (
                  data[i].content.lists &&
                  Array.isArray(data[i].content.lists)
                ) {
                  // 遍历每一个 product，并修改 icon
                  for (let j = 0; j < data[i].content.lists.length; j++) {
                    if (data[i].content.lists[j].icon) {
                      data[i].content.lists[j].icon =
                        fileUrl + data[i].content.lists[j].icon;
                    }
                  }
                }
              } catch (error) {
                console.error("JSON 解析失败:", error);
                data[i].content = null; // 或保持原字符串
              }
            }
          }
        }
        this.homeitems2 = response.data.rows;
        console.log(this.homeitems2, "解决方案");
        localStorage.setItem("homeData2", JSON.stringify(this.homeitems2));
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    //获取页面内容-成功案例
    async getHomepage3() {
      const cache = localStorage.getItem("homeData3");
      if (cache) {
        this.homeitems = JSON.parse(cache);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/homepageContent/list?type=3`
        );
        const data = response.data.rows;

        if (Array.isArray(data)) {
          for (let i = 0; i < data.length; i++) {
            if (typeof data[i].content === "string") {
              try {
                data[i].content = JSON.parse(data[i].content);
                if (Array.isArray(data[i].content.backgroundImages)) {
                  // 遍历并拼接 fileUrl
                  for (
                    let j = 0;
                    j < data[i].content.backgroundImages.length;
                    j++
                  ) {
                    if (
                      typeof data[i].content.backgroundImages[j] === "string"
                    ) {
                      data[i].content.backgroundImages[j] =
                        fileUrl + data[i].content.backgroundImages[j];
                    }
                  }
                }
              } catch (error) {
                console.error("JSON 解析失败:", error);
                data[i].content = null; // 或保持原字符串
              }
            }
          }
        }
        this.homeitems = response.data.rows;
        console.log(this.homeitems, "服务案例");
        localStorage.setItem("homeData3", JSON.stringify(this.homeitems));
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    //获取页面内容-解决方案
    async getHomepage4() {
      const cache = localStorage.getItem("homeData4");
      if (cache) {
        this.homeitems4 = JSON.parse(cache);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/homepageContent/list?type=4`
        );
        const data = response.data.rows;

        if (Array.isArray(data)) {
          for (let i = 0; i < data.length; i++) {
            if (typeof data[i].content === "string") {
              try {
                data[i].content = JSON.parse(data[i].content);
                // 检查是否存在 services 数组
                if (
                  data[i].content.services &&
                  Array.isArray(data[i].content.services)
                ) {
                  // 遍历每一个 product，并修改 backgroundImage
                  for (let j = 0; j < data[i].content.services.length; j++) {
                    if (data[i].content.services[j].backgroundImage) {
                      data[i].content.services[j].backgroundImage =
                        fileUrl + data[i].content.services[j].backgroundImage;
                    }
                  }
                }
              } catch (error) {
                console.error("JSON 解析失败:", error);
                data[i].content = null; // 或保持原字符串
              }
            }
          }
        }
        this.homeitems4 = response.data.rows;
        console.log(this.homeitems4, "咨询服务");
        localStorage.setItem("homeData4", JSON.stringify(this.homeitems4));
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    //获取页面内容-数字
    async getHomepage5() {
      const cache = localStorage.getItem("homeData5");
      if (cache) {
        this.homeitems5 = JSON.parse(cache);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/homepageContent/list?type=5`
        );
        const data = response.data.rows;

        if (Array.isArray(data)) {
          for (let i = 0; i < data.length; i++) {
            if (typeof data[i].content === "string") {
              try {
                data[i].content = JSON.parse(data[i].content);
                // 检查是否存在 services 数组
              } catch (error) {
                console.error("JSON 解析失败:", error);
                data[i].content = null; // 或保持原字符串
              }
            }
          }
        }
        this.homeitems5 = response.data.rows;
        console.log(this.homeitems5, "数字");
        localStorage.setItem("homeData5", JSON.stringify(this.homeitems5));
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    // 轮播
    /* banner-swiper */

    initSwiper() {
      if (this.bannerSwiper) {
        this.bannerSwiper.destroy(); // 销毁旧的 Swiper 实例
      }
      this.bannerSwiper = new Swiper(".banner-swiper", {
        loop: true, // 循环模式选项
        effect: "fade",
        //自动播放
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 延迟加载
        lazy: {
          loadPrevNext: true,
        },
      });
    },
    //跳转
    // 跳转到产品中心，并切换到与所点卡片顺序对应的 tab
    goToPage(index) {
      this.$router.push({
        path: "/product/center",
        query: { tabIndex: index },
      });
    },
    goToPage1(item) {
      // 跳转到对应的产品详情页面
      this.$router.push({
        path: "/product/success",
        // name: "product",

        params: {
          // belongClass: "1933044359565864961",
          // id: item.id,
        },
      });
    },
    // 跳转到智能化解决方案，并切换到与当前 tab 顺序对应的 tab
    RouterService(index) {
      this.$router.push({
        path: "/service",
        query: { tabIndex: index },
      });
    },
    //表单提交
    showConsultDialog() {
      this.dialogVisible = true;
    },
    handleClose(done) {
      this.resetForm();
      this.dialogVisible = false;
      done && done(); // 重要：确保调用done回调
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 这里可以添加提交表单的逻辑
          axios
            .post( `${websiteUrl}` + "/mes-official-website-manage/aboutInformationGathering/add", this.form)
            .then((response) => {
              this.$message.success("提交成功！我们将尽快与您联系");
              this.dialogVisible = false;
              this.resetForm();
            })
            .catch((error) => {
              this.$message.error("提交失败，请稍后重试");
            });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
  },
  mounted() {
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
    translatePage();
  },
};
</script>
<style>
a {
  text-decoration: none;
}
/* element组件样式调整 */
.el-tabs__item:hover {
  color: #003987;
  cursor: pointer;
}
.el-tabs__item {
  font-size: 20px;
}
.el-tabs__item.is-active {
  color: #003987;
  font-size: 24px;
}
.el-tabs__active-bar {
  background-color: #003987;
}
/* 整体盒子 */
#HomePage {
  width: 100%;
  margin-top: 60px;
}

/* 轮播图 */
/* 默认高度（PC端） */
.certificate-carousel {
  height: 600px;
}
.certificate-item {
  position: relative;
  width: 100%;
  height: 100%;
}

.certificate-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(51, 51, 51, 0.534);
  text-align: center;
  line-height: 80px;
}
.swiper-slide-title > h1 {
  font-size: 50px;
  margin-top: 12%;
}
.swiper-slide-title > p {
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}

/* 产品中心 */
.product {
  min-height: 700px;
  height: auto;
  padding: 0 0 60px 0;
}
/* 智能解决方案 */
#bigData {
  padding: 10px 0 0 0;
  transition: all ease 0.6s;
  box-sizing: border-box;
}
#bigData .bigData-container {
  height: 420px;
  display: flex;
  align-items: stretch;
}
#bigData .bigData-container .col-md-6 {
  display: flex;
  flex-direction: column;
  height: 100%;
}
#bigData .bigData-container .col-md-6:first-child {
  justify-content: center;
}
#bigData .bigData-container .img-responsive {
  width: 100%;
  height: 400px;
  object-fit: contain;
  margin: 0 auto;
}
#bigData .bigData-container .col-md-6:last-child {
  justify-content: space-between;
}
#bigData .bigData-container .col-md-6:last-child h2 {
  flex-shrink: 0;
}
#bigData .bigData-container .col-md-6:last-child p {
  flex: 1;
  overflow-y: auto;
  margin: 0;
  padding-right: 10px;
  text-align: left;      /* 靠左对齐（p默认就是左对齐，但显式写出更安全） */
  text-indent: 2em;      /* 首行缩进2个汉字（基于当前字体大小自动计算） */
  font-size: 17px !important;
}
#bigData .btnsty {
  margin-top: auto;
  flex-shrink: 0;
}
#bigData .bigData-title {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
#bigData p {
  font-size: 14px !important;
  color: #333 !important;
  line-height: 2rem !important;
}
#bigData .bigData-device {
  margin: 0 0 0 20px;
}
.btnsty {
  display: block;
  width: 160px;
  background-color: #fff;
  border: 1px solid #003987;
  line-height: 40px;
  font-size: 16px;
  color: #003987;
  margin-top: 62px;
  text-align: center;
  cursor: pointer;
}
.btnsty:hover {
  text-decoration: none;
  background-color: #003987;
  color: #fff !important;
}
/* 成功案例 */
.anlsty {
  display: block;
  position: absolute;
  left: 0;
  width: 100%;
  height: 100px;
  color: white;
  text-align: center;
  line-height: 100px;
}
.cg_div {
  width: 800px;
  height: 242px;
  background: linear-gradient(
    to right,
    rgba(0, 57, 135, 0.1),
    rgba(0, 57, 135, 0.8) 50%,
    rgba(0, 57, 135, 0.1) 100%
  );
  text-align: center;
  color: #fff;
  position: absolute;
  z-index: 99;
  left: 30%;
  margin-top: 100px;
  cursor: pointer;
}
.cg_h4 {
  margin-top: 30px;
  font-size: 36px;
  line-height: 50px;
}
.cg_h2 {
  font-size: 110px;
  font-family: arial;
  line-height: 116px;
  height: 116px;
  font-weight: bold;
  transition: all 2s ease;
}

/* 咨询服务 */
.fwimgsty {
  width: 300px;
  height: 415px;
  position: absolute;
  z-index: -1;
}
.index-fw {
  display: block;
  width: 100%;
  height: auto;
  padding: 92px 0 114px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  z-index: 1;
}
.index-fw-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.index-fw-list li {
  float: left;
  width: 25%;
  height: 415px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  overflow: hidden;
}
.index-fw-in {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
  padding: 82px 40px 0;
  color: #fff;
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
  background: linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.6));
}
.index-fw-in:hover {
  background-color: rgba(0, 57, 135, 0.85);
  text-decoration: none;
}
.index-fw-in h3 {
  text-align: center;
  font-size: 24px;
  line-height: 36px;
  margin-top: 50px;
  transition: all 0.3s ease;
}
.index-fw-in:hover h3 {
  margin-top: 0;
  color: #fff;
}
.index-fw-in p {
  font-size: 14px;
  line-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  margin: 0;
}
.index-fw-in span {
  display: none;
  width: 160px;
  height: 40px;
  margin: 26px auto 0;
  text-align: center;
  line-height: 40px;
  background-color: #ffffff;
  font-size: 18px;
  color: #2b5fbc;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
}
.index-fw-in:hover span {
  display: block;
}
.index-fw-in em {
  display: block;
  width: 18px;
  height: 1px;
  background-color: #fff;
  margin: 13px auto 11px;
}
.index-fw-in em img {
  display: none;
}
.index-fw-in:hover em img {
  display: block;
}
.index-fw-in:hover em {
  width: 20px;
  height: 15px;
  margin: 11px auto 10px;
  background: none;
}
.width {
  display: block;
  width: 1200px;
  margin: 0 auto;
  height: auto;
}
.clear {
  clear: both;
}
.clear::after {
  content: "";
  height: 0;
  display: block;
  clear: both;
}
/* 数字滚动 */
.numberBot {
  display: block;
  width: 100%;
  height: 232px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: #2661c1;
  clear: both;
  position: relative;
  z-index: 1;
}
.number li {
  float: left;
  width: 25%;
  height: 232px;
  text-align: center;
  color: #fff;
  padding-top: 10px;
  position: relative;
}
.number li h3 {
  line-height: 102px;
  height: 102px;
  overflow: hidden;
  font-size: 22px;
}
.number li h3 span {
  font-size: 74px;
  font-family: arial;
}
.number li p {
  font-size: 16px;
  line-height: 24px;
}
.number li::after {
  content: "";
  display: block;
  width: 1px;
  height: 66px;
  background: #5f8fd1;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}
.number li:last-child::after {
  display: none;
}
/* 为什么选择我们 */
#whyChooseUs {
  padding: 100px;
  position: relative;
  z-index: 1;
  clear: both;
}
#whyChooseUs .whyChooseUs-title {
  margin-bottom: 50px;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
  font-size: 38px;
  font-weight: 500;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
  font-size: 14px;
}
#whyChooseUs .server-block {
  display: flex;
  flex-direction: column;
  height: 350px;
  padding: 30px 20px;
  border-bottom: 5px solid #ccc;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
  cursor: pointer;
}
#whyChooseUs .server-block img {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  object-fit: contain;
  flex-shrink: 0;
}
#whyChooseUs .server-block > p {
  font-size: 20px;
  margin: 30px 0 10px 0;
  flex-shrink: 0;
  text-align: center;
}
#whyChooseUs .server-block > div {
  flex: 1;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  text-align: left;
  text-indent: 2em;
  color: #333;
  font-size: 14px;
  line-height: 1.5;
  margin-top: 0;
}

/* 简洁版咨询弹窗样式 */
.el-dialog {
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: none;
}
.el-dialog__header {
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
}
.el-dialog__title {
  color: #333;
  font-size: 17px;
  font-weight: 500;
}
.el-dialog__body {
  padding: 24px;
}
.el-dialog__footer {
  padding: 16px 24px;
  background-color: #fafafa;
  border-top: 1px solid #f0f0f0;
  text-align: right;
}
.el-form-item__label {
  color: #666;
  font-weight: normal;
}
.el-input__inner,
.el-textarea__inner,
.el-select .el-input__inner {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fff;
  transition: all 0.2s;
}
.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: #409eff;
  outline: none;
}
.el-button {
  border-radius: 4px;
  padding: 9px 20px;
  font-weight: 500;
}
.el-button--primary {
  background-color: #409eff;
  border-color: #409eff;
  color: white;
}
.el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}
.el-button:not(.el-button--primary) {
  border: 1px solid #dcdfe6;
  color: #606266;
}
.el-button:not(.el-button--primary):hover {
  border-color: #c0c4cc;
  color: #409eff;
}

/* ========== 平板端适配（768px - 1024px） ========== */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  /* 轮播图 */
  .certificate-carousel {
    height: 400px;
  }
  .swiper-slide-title > h1 {
    font-size: 35px;
    margin-top: 12%;
  }
  .swiper-slide-title > p {
    font-size: 16px;
    margin-top: 1%;
  }

  /* 产品中心 */
  .product {
    padding: 0 0 40px 0;
  }

  /* 智能解决方案 */
  #bigData .bigData-container {
    height: auto;
    min-height: 380px;
  }
  #bigData .bigData-container .img-responsive {
    height: 300px;
  }
  #bigData .bigData-title {
    font-size: 28px;
  }
  #bigData p {
    font-size: 14px !important;
    line-height: 1.6rem !important;
  }
  .btnsty {
    width: 140px;
    line-height: 38px;
    font-size: 14px;
    margin-top: 30px;
  }

  /* 成功案例 */
  .cg_div {
    width: 90%;
    left: 5%;
    margin-top: 50px;
  }
  .cg_h4 {
    font-size: 28px;
    margin-top: 20px;
  }
  .cg_h2 {
    font-size: 70px;
    line-height: 80px;
    height: 80px;
  }
  .anlsty {
    height: 80px;
  }

  /* 咨询服务 */
  .index-fw {
    padding: 60px 0 80px;
  }
  .index-fw-list li {
    width: 50%;
    height: 380px;
  }
  .fwimgsty {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .index-fw-in {
    padding: 60px 30px 0;
  }
  .index-fw-in h3 {
    font-size: 22px;
    margin-top: 40px;
  }
  .width {
    width: 100%;
    padding: 0 20px;
  }

  /* 数字滚动 */
  .numberBot {
    height: auto;
    padding: 30px 0;
  }
  .number li {
    width: 50%;
    margin-bottom: 30px;
  }
  .number li::after {
    display: none;
  }
  .number li:nth-child(odd)::after {
    display: block;
    right: 0;
  }
  .number li:nth-child(even)::after {
    display: none;
  }

  /* 为什么选择我们 */
  #whyChooseUs {
    padding: 60px 20px;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
    font-size: 32px;
  }
  #whyChooseUs .server-block {
    height: 320px;
    margin-bottom: 20px;
  }
  #whyChooseUs .server-block img {
    width: 60px;
    height: 60px;
  }
  #whyChooseUs .server-block > p {
    font-size: 18px;
    margin: 20px 0 10px;
  }

  /* Tabs样式 */
  .el-tabs__item {
    font-size: 18px;
  }
  .el-tabs__item.is-active {
    font-size: 20px;
  }
}
.text-content-wrapper {
  display: flex;
  align-items: center;      /* 垂直居中 */
  justify-content: center;  /* 水平居中，可选 */
  height: 100%;             /* 或具体高度 */
  min-height: 120px;        /* 保证有足够高度 */
}

.centered-text {
  margin: 0;                /* 移除默认边距 */
  text-align: left;         /* 保持文本左对齐 */
  text-indent: 2em;
  font-size: 17px;
  line-height: 1.8;
  /* 限制最大行数，防止溢出 */
  max-height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /* -webkit-line-clamp: 4;    限制显示行数 */
  -webkit-box-orient: vertical;
}
/* ========== 手机端适配（<768px） ========== */
@media screen and (max-width: 767px) {
  /* 整体 */
  #HomePage {
    margin-top: 50px;
  }

  /* 轮播图 */
  .certificate-carousel {
    height: 250px;
  }
  .swiper-slide-title > h1 {
    font-size: 20px;
    margin-top: 25%;
  }
  .swiper-slide-title > p {
    font-size: 12px;
    margin-top: 5%;
    padding: 0 15px;
  }

  /* 智能解决方案 */
  #bigData {
    padding: 20px 15px;
  }
  #bigData .bigData-container {
    height: auto;
    flex-direction: column;
  }
  #bigData .bigData-container .col-md-6 {
    width: 100%;
  }
  #bigData .bigData-container .img-responsive {
    height: 200px;
    margin-bottom: 20px;
  }
  #bigData .bigData-title {
    font-size: 22px;
    margin-top: 15px;
  }
  #bigData p {
    font-size: 13px !important;
    line-height: 1.5rem !important;
    margin: 15px 0;
  }
  .btnsty {
    width: 120px;
    line-height: 36px;
    font-size: 13px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  /* 成功案例 */
  .cg_div {
    width: 95%;
    left: 2.5%;
    margin-top: 30px;
    height: auto;
    padding: 15px 10px;
  }
  .cg_h4 {
    font-size: 18px;
    line-height: 30px;
    margin-top: 10px;
  }
  .cg_h2 {
    font-size: 40px;
    line-height: 50px;
    height: auto;
  }
  .anlsty {
    height: 60px;
  }
  /* 产品中心 */
  .product {
    min-height: 400px;  /* 这里原来是 700px */
    padding: 0 0 30px 0;
  }
  /* 咨询服务 */
  .index-fw {
    padding: 40px 0 50px;
  }
  .index-fw-list {
    margin: 0;
    padding: 0;
  }
  .index-fw-list li {
    width: 100%;
    height: 320px;
    margin-bottom: 20px;
    float: none;
  }
  .index-fw-list li:last-child {
    margin-bottom: 0;
  }
  .fwimgsty {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .index-fw-in {
    padding: 50px 25px 0;
  }
  .index-fw-in h3 {
    font-size: 20px;
    margin-top: 30px;
  }
  .index-fw-in p {
    font-size: 13px;
    line-height: 24px;
    -webkit-line-clamp: 3;
  }
  .index-fw-in span {
    width: 130px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
  }
  .width {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
  }

  /* 数字滚动 */
  .numberBot {
    height: auto;
    padding: 20px 0;
    margin-top: 0 !important;
    clear: both;
  }
  .number li {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    padding: 10px 0;
  }
  .number li h3 {
    line-height: 60px;
    height: 60px;
  }
  .number li h3 span {
    font-size: 48px;
  }
  .number li p {
    font-size: 14px;
  }
  .number li::after {
    display: none;
  }

  /* 为什么选择我们 */
  #whyChooseUs {
    padding: 30px 15px;
    clear: both;
  }
  #whyChooseUs .whyChooseUs-title {
    margin-bottom: 30px;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
    font-size: 24px;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
    font-size: 12px;
  }
  #whyChooseUs .server-block {
    height: auto;
    min-height: 280px;
    margin-bottom: 20px;
    padding: 20px 15px;
  }
  #whyChooseUs .server-block img {
    width: 50px;
    height: 50px;
  }
  #whyChooseUs .server-block > p {
    font-size: 16px;
    margin: 15px 0 10px;
  }
  #whyChooseUs .server-block > div {
    -webkit-line-clamp: unset;
    overflow: visible;
    text-indent: 1.5em;
    font-size: 13px;
  }

  /* Tabs样式 */
  .el-tabs__item {
    font-size: 14px;
    padding: 0 10px;
  }
  .el-tabs__item.is-active {
    font-size: 16px;
  }
  .el-tabs__nav-wrap::after {
    height: 1px;
  }

  /* 弹窗样式 */
  .el-dialog {
    width: 90% !important;
    margin-top: 5vh !important;
  }
  .el-dialog__body {
    padding: 15px;
  }
  .el-form-item {
    margin-bottom: 18px;
  }
  .el-form-item__label {
    font-size: 13px;
  }
}

/* ========== 小屏手机优化（<480px） ========== */
@media screen and (max-width: 480px) {
  /* 轮播图 */
  .certificate-carousel {
    height: 200px;
  }
  .swiper-slide-title > h1 {
    font-size: 18px;
    margin-top: 30%;
  }
  .swiper-slide-title > p {
    font-size: 10px;
  }

  /* 智能解决方案 */
  #bigData .bigData-title {
    font-size: 18px;
  }
  .btnsty {
    width: 100px;
    line-height: 32px;
    font-size: 12px;
  }

  /* 成功案例 */
  .cg_h4 {
    font-size: 16px;
    line-height: 24px;
  }
  .cg_h2 {
    font-size: 32px;
    line-height: 40px;
  }

  /* 咨询服务 */
  .index-fw-in {
    padding: 40px 20px 0;
  }
  .index-fw-in h3 {
    font-size: 18px;
    margin-top: 20px;
  }
  .index-fw-in p {
    font-size: 12px;
    line-height: 20px;
  }
  .index-fw-in span {
    width: 110px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
  }

  /* 为什么选择我们 */
  #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
    font-size: 20px;
  }
  #whyChooseUs .server-block {
    min-height: 260px;
  }
  #whyChooseUs .server-block img {
    width: 45px;
    height: 45px;
  }
  #whyChooseUs .server-block > p {
    font-size: 15px;
  }

  /* Tabs样式 */
  .el-tabs__item {
    font-size: 12px;
    padding: 0 8px;
  }
  .el-tabs__item.is-active {
    font-size: 14px;
  }
}

/* 横屏手机适配 */
@media screen and (max-width: 767px) and (orientation: landscape) {
  /* 咨询服务横屏优化 */
  .index-fw-list li {
    height: 280px;
  }
  .index-fw-in {
    padding: 30px 20px 0;
  }
  .index-fw-in h3 {
    font-size: 18px;
    margin-top: 20px;
  }
  .index-fw-in p {
    font-size: 12px;
    line-height: 20px;
    -webkit-line-clamp: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/HomePage.vue